export default __webpack_public_path__ + "static/team-1-6867ad1b64fb97f5e2dde61e22297247.png";